export const UsageOptionTexts: Record<string, string> = {
  '/train/v2/create_fast_training_run': t('Training'),
  '/train/create_fast_training_run': t('Training'),
  '/train/create_training_run': t('Training'),
  '/inference/v1/predict': t('Inference'),
  '/inference/v2/predict': t('Inference'),
  '/ocr/v1/detect-text': t('OCR'),
};
